<template>
		<div>
			<main style='background: #EEEEEE;height: 900px;'>
					<img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
					<div class="centerBox">
						<div class="liucheng">
							<div>
								<p style="width: 100%;text-align: center;font-size: 30px;
font-family: Microsoft YaHei, Microsoft YaHei-Bold;
font-weight: 700;
text-align: center;
color: #333333;
line-height: 24px;
letter-spacing: 2px;margin-bottom: 40px;">“鉴调一体”新模式</p>
								<p style="width:100%;font-size: 16px;font-family: Microsoft YaHei, Microsoft YaHei-Regular;font-weight: 400;text-align: left;color: #333333;line-height: 30px;letter-spacing: 1px;">
								    <img src="../../../images/pic_jdyth.png" align="left" width="258" hspace="5" vspace="5" style="margin-right: 25px;">
								    “鉴调一体”模式是鉴定人员联手调解员，让专业的人来说和专业的事，化解群众纠纷，让群众维权不犯难。每一例鉴定项目的背后，都是一起难解的矛盾纠纷。鉴定意见的形成，意味着当事人一方受到人身伤害的程度有了科学结论。但造成这个伤害的原因和责任是什么，谁来为这个伤害买单，往往需要相关当事人到法院、公安交警、人社劳动、仲裁部门、保险公司、医院、律师事务所等部门单位进行起诉立案、聘请律师、开具证明、查找证据等维权活动，给当事人带来的经济压力、精神痛苦，以及由此可能导致的矛盾加剧，极易让权益本该受到保护的一方深感无助。 “鉴调一体”，就是对各种类型的人身损害赔偿纠纷案件，只要有关部门、组织或个人申请了司法鉴定，司法医学鉴定中心在向当事人送达鉴定意见书时，都会鼓励、引导当事人到司法医学鉴定中心设立的人身损害赔偿纠纷调委会接受公益、无偿的人民调解。同时，人身损害赔偿纠纷人民调解委员会受理的当事人未申请鉴定的调解案件，在纠纷调解过程中，认为有必要依据鉴定结论促使当事人就赔偿意见达成一致时，则告知当事人到鉴定中心申请鉴定。 鉴调一体”新模式的推行，不但及时化解了大量矛盾纠纷，使人民群众合法权益得以有效维护，社会公平正义得以有效促进，矛盾就地化解不上交，还节省了大量行政资源，减少了诉讼拖累，减轻了群众负担，实现了政治效果、法律效果和社会效果的有机统一。
								</p>
							</div>
						</div>
					</div>
			</main>
		</div>
</template>

<script>

import navheader from '../../components/navheader.vue'
import footeritem from '../../components/footeritem.vue'
import axios from 'axios'
import '../../assets/css/index.less'
import '../../assets/css/fuWu.less';
export default {
	name: 'Pdf',
	components: {
		navheader,
		footeritem
	},
	data() {
		return {
			activeNum: 0,
			list: [
				{ name: '关于协会' },
				{ name: '协会简介' },
				{ name: '协会章程' },
				{ name: '组织机构' },
				{ name: '理事会' },
				{ name: '秘书处' },
				],
		};
	},
	methods: {
		select (item, index) {
		  this.activeNum = index
		  if (index === 1) {
		    setTimeout(() => {
		      var map = new BMap.Map("container");    
		      var point = new BMap.Point(114.662576,38.044547);    
		      map.centerAndZoom(point, 15); 
		      var opts = {anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_LARGE} 
		      map.addControl(new BMap.NavigationControl(opts));
		      var marker = new BMap.Marker(point);
		      map.addOverlay(marker);  
		      map.enableScrollWheelZoom(true);
		      var information = {    
		        width : 200,     // 信息窗口宽度    
		        height: 100,     // 信息窗口高度 
		        offset: {height: -20, width: 0}
		      }
		      var html = `<div class="baidu-map">
		        <p>
		          中经天平司法鉴定中心
		        </p>
		        <p>
		          长江大道315号创新大厦A座9-903室
		        </p>
		        <p>
		          联系电话：0311-89929485
		        </p>
		      </div>
		      `
		      var infoWindow = new BMap.InfoWindow(html, information);  // 创建信息窗口对象    
		      map.openInfoWindow(infoWindow, map.getCenter());
		      marker.addEventListener("click", function() {
		        var information = {    
		          width : 200,     // 信息窗口宽度    
		          height: 90,     // 信息窗口高度 
		        }
		        var infoWindow = new BMap.InfoWindow(html, information);
		        // 调用了marker对象的openInfoWindow方法
		        this.openInfoWindow(infoWindow); 
		      });
		    }, 200)
		  }
		  }
	},
	created(){
		
	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.topImg{
		width: 100%;
		display: block;
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.titleTip{
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}
	.liucheng {
		position: absolute;
		top: 300px;
		
	  // background: #F8F8F8;
	  // padding: 30px 0;
	  &>div {
	    width: 1134px;
		height: 700px;
	    margin: 0 auto;
	    padding: 60px 90px;
		border-radius: 20px;
	    box-sizing: border-box;
	    // border-radius: 10px;
	    background: #fff;
	    overflow: hidden;
	    &>ul {
	      float: left;
	      &>li {
	        width: 150px;
	        line-height: 50px;
	        text-align: center;
	        cursor: pointer;
	        position: relative;
	        &::after {
	          position: absolute;
	          right: -16px;
	          top: 16px;
	          display: inline-block;
	          content: '';
	          border: 8px solid transparent;
	        }
	        &.active {
	          background: #076CE0;
	          color: #fff;
	          &::after {
	            border-left-color: #076CE0;
	          }
	        }
	      }
	    }
	    &>div {
	      width: calc(100% - 300px);
	          padding: 20px;
	          box-sizing: border-box;
	          padding-top: 0;
			  float: right;
			  overflow: hidden;
	      .lianxi {
	        p {
	          span {
	            display: inline-block;
	            width: 80px;
	            text-align: right;
	            margin-right: 20px;
	          }
	          margin-top: 20px;
	        }
	      }
	    }
	  }
	  @media screen and (max-width: 1024px) {
	    &>div {
	      width: 90%;
	    }
	  }
	}
</style>
